import { render, staticRenderFns } from "./StandByList.vue?vue&type=template&id=0dca6cce&scoped=true"
import script from "./StandByList.vue?vue&type=script&lang=js"
export * from "./StandByList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca6cce",
  null
  
)

export default component.exports